!function () {
    "use strict"; var e = {
        1567: function (e,
            t) {
            const n = "above-overlay",
                s = new Set; t.A = class {
                    isClosingTimer = null; attachedElements = new Set; constructor(e = document.querySelector("#main-content")) {
                        this.container = e,
                            this.overlay = document.createElement("div"),
                            this.overlay.innerHTML = "&nbsp;",
                            this.overlay.classList.add("overlay"),
                            this.overlay.addEventListener("transitionend",
                                e => {
                                    "opacity" !== e.propertyName || this.isOpen || (this.attachedElements && this.attachedElements.size && this.attachedElements.forEach(e => { this.detachElement(e) }),
                                        this.afterClosed && (this.afterClosed(),
                                            this.afterClosed = null),
                                        this.detachOverlay()),
                                    "opacity" === e.propertyName && this.isOpen && this.afterOpened && (this.afterOpened(),
                                        this.afterOpened = null)
                                }),
                            s.add(this)
                    } attachOverlay() { this.container.appendChild(this.overlay) }
                    detachOverlay() {
                        this.container.removeChild(this.overlay)
                    } async open({
                        attachElements: e,
                        afterOpened: t,
                        beforeOpened: s
                    } = {}) {
                        await this.attachOverlay(),
                        this.isClosingTimer && (clearTimeout(this.isClosingTimer),
                            this.isClosingTimer = null),
                        s && s(),
                        e && (e.forEach(e => { this.attachedElements.add(e) }),
                            this.attachedElements.forEach(e => { e.classList.add(n) })),
                        requestAnimationFrame(() => { this.overlay.classList.add("open") }),
                        t && (this.afterOpened = t)
                    } close({ delay: e,
                        beforeClosed: t,
                        afterClosed: n } = {}) {
                        t && t(),
                            this.afterClosed = n; const s = () => {
                                requestAnimationFrame(() => { this.overlay.classList.remove("open") })
                            }; e ? this.isClosingTimer = setTimeout(s,
                                e) : s()
                    } detachElement(e) {
                        this.attachedElements.has(e) && e.classList.contains(n) && (e.classList.remove(n),
                            this.attachedElements.delete(e))
                    } get isOpen() { return this.overlay.classList.contains("open") } onClick(e = () => { }) {
                        e && this.overlay.addEventListener("click",
                            e)
                    } removeOnClick(e = () => { }) {
                        e && this.overlay.removeEventListener("click",
                            e)
                    } onHover(e = () => { }) {
                        e && this.overlay.addEventListener("mouseover",
                            t => { this.isOpen && e(t) })
                    }
                }

        },
        4662: function (e,
            t,
            n) {
            n.d(t,
                {
                    My: function () { return r },
                    jW: function () { return s },
                    oM: function () { return c },
                    qF: function () { return d }
                }); const s = (e = !1) => {
                    const t = window.innerWidth - document.body.offsetWidth,
                    n = document.getElementById("nav-wrapper"); e ? (document.body.classList.add("no-scroll"),
                        document.body.style.paddingRight = t + "px",
                        n.style.paddingRight = t + "px") : (document.body.classList.remove("no-scroll"),
                            document.body.style.paddingRight = "0px",
                            n.style.paddingRight = "0px")
                }; let i = () => { }; const o = e => {
                    "Escape" === e.key && (i(),
                        window.removeEventListener("keydown",
                            o))
                },
                    r = (e = !1,
                        t) => {
                            t && (i = t),
                            e && window.addEventListener("keydown",
                                o),
                            e || window.removeEventListener("keydown",
                                o)
                    }; document.querySelectorAll(".local-scroll").forEach(e => {
                        e.addEventListener("click",
                            e => {
                                e.preventDefault(),
                                    e.stopPropagation(); const t = e.target.getAttribute("href"); !function (e,
                                        t = 0) {
                                        const n = document.getElementById("nav-wrapper"),
                                            s = document.querySelector(".header").getAttribute("data-ux-position"),
                                            i = e.getBoundingClientRect().top; window.scrollTo({
                                                top: "off" !== s ? i + window.scrollY - t + parseFloat(n.style.marginTop) : i + window.scrollY - t,
                                                behavior: "smooth"
                                            })
                                    }(document.querySelector(t))
                            })
                    }); const a = {}; function c(e,
                        t = e) {
                const n = function (e) { return Array.from(e.querySelectorAll('summary, a[href], button:not([disabled]), [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe')) }(e),
                    s = n[0],
                    i = n[n.length - 1]; d(),
                        a.focusin = t => {
                            t.target !== e && t.target !== i && t.target !== s || document.addEventListener("keydown",
                                a.keydown)
                        },
                        a.focusout = function () {
                            document.removeEventListener("keydown",
                                a.keydown)
                        },
                        a.keydown = function (t) {
                            "TAB" === t.code.toUpperCase() && (t.target !== i || t.shiftKey || (t.preventDefault(),
                                s.focus()),
                                t.target !== e && t.target !== s || !t.shiftKey || (t.preventDefault(),
                                    i.focus()))
                        },
                        document.addEventListener("focusout",
                            a.focusout),
                        document.addEventListener("focusin",
                            a.focusin),
                        t.focus()
            } function d(e) {
                document.removeEventListener("focusin",
                    a.focusin),
                document.removeEventListener("focusout",
                    a.focusout),
                document.removeEventListener("keydown",
                    a.keydown),
                e && e.focus()
            }
        }
    },
        t = {}; function n(s) {
            var i = t[s]; if (void 0 !== i) return i.exports; var o = t[s] = { exports: {} }; return e[s](o,
                o.exports,
                n),
                o.exports
        } n.d = function (e,
            t) {
                for (var s in t) n.o(t,
                    s) && !n.o(e,
                        s) && Object.defineProperty(e,
                            s,
                            {
                                enumerable: !0,
                                get: t[s]
                            })
        },
            n.o = function (e,
                t) {
                    return Object.prototype.hasOwnProperty.call(e,
                        t)
            }; var s = n(1567),
                i = n(4662); const o = new s.A; class r extends HTMLElement {
        constructor() {
            super(),
            this.close = this.close.bind(this),
            this.open = this.open.bind(this),
            this.chatbot = this,
            this.chatbotOpenButtons = document.querySelectorAll("button[name='chatbot-open']"),
            this.body = document.querySelector("body")
        } connectedCallback() {
            this.chatbot.parentElement !== this.body && this.body.appendChild(this.chatbot),
                this.addEventListeners()
        } addEventListeners() {
            this.querySelector("#chatbot-close").addEventListener("click",
                this.close)
        } open() {
            o.open({ attachElements: [this] }),
            o.onClick(this.close.bind(this)),
            requestAnimationFrame(() => { this.classList.add("open") }),
            (0,
                i.My)(!0,
                    this.escCallBack.bind(this)),
            (0,
                i.jW)(!0),
            o.open({ attachElements: [this.chatbot] }),
            o.onClick(this.close),
            this.chatbot.classList.add("open"),
            this.chatbot.focus(),
            (0, i.oM)(this.chatbot)
        } close() {
            this.chatbot.classList.remove("open"),
            o.removeOnClick(this.close),
            o.close(),
            requestAnimationFrame(() => { this.classList.remove("open") }),
            (0,
                i.My)(!1,
                    this.escCallBack),
            (0,
                i.jW)(!1),
            (0,
                i.qF)(this.chatbot)
        } escCallBack() { this.close() }
    } customElements.get("chatbot-drawer-component") || customElements.define("chatbot-drawer-component",
        r)
}();